import {
  Directive,
  OnInit,
  ElementRef,
  Renderer2,
  HostBinding,
  OnDestroy,
} from '@angular/core';
import { OrganizationService } from '../../organizations/organization.service';
import { ThemeService } from '../services/theme.service';
import { Subject } from 'rxjs';
import { Organization } from '../sdk';
import { takeUntil, switchMap, filter } from 'rxjs/operators';

@Directive({
  selector: '[appPrimaryColor]',
})
export class PrimaryColorDirective implements OnInit, OnDestroy {
  primaryColor: string;
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    private orgService: OrganizationService,
    private themeService: ThemeService,
  ) {}

  @HostBinding('style.color') color: string;

  ngOnInit() {
    this.orgService.active
      .pipe(
        filter((org) => !!org),
        switchMap((org: Organization) => {
          this.primaryColor = this.orgService.findDefault(
            org,
            'color_main',
          ).value;

          if (this.primaryColor) {
            this.color = '#' + this.color;
          }

          return this.themeService.dark;
        }),
        takeUntil(this.onDestroy$),
      )
      .subscribe(isDark => (this.color = isDark ? '' : this.primaryColor));
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
